import { defineMessages } from 'react-intl';

export default defineMessages({
  yes: 'Yes',
  no: 'No',
});
